'use client'

import type { State } from '@/core/action'
import * as React from 'react'

type FormProps<T = unknown> = React.FormHTMLAttributes<HTMLFormElement> & {
  state: State<T>
}

const FormContext = React.createContext<State>(null)

export const useFormContext = () => {
  return React.useContext(FormContext)
}

export function Form<T = unknown>({ state, ...props }: FormProps<T>) {
  return (
    <FormContext.Provider value={state}>
      <form {...props} />
    </FormContext.Provider>
  )
}
